<template>
    <department-picker-new
        v-model="department"
        class="w-full min-w-[200px] ag-custom-component-popup"
        default-open
        @on-account-picker-closed="stopEditing"
    />
</template>

<script setup lang="ts">
import {SubAccount} from '@/subaccount/types/SubAccount'
import {computed} from 'vue'
import {fetchSuppliers, updateSubAccount} from '@/subaccount/subAccount.service'
import DepartmentPickerNew from '@/dimensions/DepartmentPickerNew.vue'

const props = defineProps({
    params: {
        type: Object as () => {
            value: string,
            node: {
                data: SubAccount
            },
            stopEditing: () => void
        },
        required: true
    }
})

const subAccount = computed(() => {
    return props.params.node.data
})

const department = computed({
    get: () => {
        return subAccount.value.metadata.suggestions.department || ''
    },
    set: async (value) => {
        const updatedSubAcc = {
            ...subAccount.value,
            metadata: {
                ...subAccount.value.metadata,
                suggestions: {
                    ...subAccount.value.metadata.suggestions,
                    department: value
                }
            }
        }
        await updateSubAccount(updatedSubAcc)
        await fetchSuppliers()
        stopEditing()
    }
})

const stopEditing = () => {
    props.params.stopEditing()
}

</script>

<style scoped>

</style>